import { createLogger, MutationPayload, Store as VueStore } from 'vuex';
import { ConfigModule } from './modules/ConfigModule';
import { LanguageModule } from './modules/LanguageModules';
import { MetaModule } from './modules/MetaModule';
import { TerminalModule } from './modules/TerminalModule';

class Store extends VueStore<any> {
	get(
		getter: string | [string, any],
		action?: string | [string, any],
		force?: boolean,
	) {
		if (typeof getter === 'string') {
			getter = [getter, undefined];
		}

		if (typeof action === 'string') {
			action = [action, undefined];
		}

		if (!(getter[0] in this.getters)) {
			throw new Error('unknown getter: ' + getter[0]);
		}

		const isGetterFunction = typeof this.getters[getter[0]] === 'function';

		if (
			action !== undefined &&
			(
				force ||
				(!isGetterFunction ? this.getters[getter[0]] : this.getters[getter[0]](getter[1])) === undefined
			)
		) {
			this.dispatch(action[0], action[1]);
		}

		return !isGetterFunction ? this.getters[getter[0]] : this.getters[getter[0]](getter[1]);
	}

	sub(
		mutation: string,
		callback: (payload: any) => any,
		once: boolean = true,
	) {
		// create subscription
		const storeUnsub = store.subscribe((mutationPayload: MutationPayload) => {
			if (mutationPayload.type === mutation) {
				// unsub immediately
				if (once === true) {
					storeUnsub();
				}

				// payload callback
				callback(mutationPayload.payload);
			}
		});

		return storeUnsub;
	}
}

const plugins = [];

if (process.env.NODE_ENV !== 'production') {
	plugins.push(createLogger());
}

const store = new Store({
	strict: process.env.NODE_ENV !== 'production',
	modules: {
		MetaModule,
		ConfigModule,
		LanguageModule,
		TerminalModule,
	},
	plugins,
});


export default store;
